import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Landing hero visual: looping crossfade between an aspirational "before" and "after"
 * photorealistic image (generated once via Gemini Nano Banana into /public).
 * Purely decorative — sits opposite the H1/CTA in the hero.
 */
const MorphingLandingVisual = () => {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setPhase((p) => (p === 0 ? 1 : 0)), 3200);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      className="relative w-full max-w-md aspect-[3/4] rounded-[2rem] overflow-hidden bg-[#F2EFE9] shadow-[0_20px_60px_-20px_rgba(26,36,33,0.25)]"
      data-testid="landing-morph-visual"
    >
      <AnimatePresence initial={false} mode="sync">
        {phase === 0 ? (
          <motion.img
            key="before"
            src="/landing-before.png"
            alt="Where you are"
            className="absolute inset-0 w-full h-full object-cover"
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 1.02 }}
            transition={{ duration: 1.8, ease: 'easeInOut' }}
            data-testid="landing-morph-before"
          />
        ) : (
          <motion.img
            key="after"
            src="/landing-after.png"
            alt="Where you're heading"
            className="absolute inset-0 w-full h-full object-cover"
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 1.02 }}
            transition={{ duration: 1.8, ease: 'easeInOut' }}
            data-testid="landing-morph-after"
          />
        )}
      </AnimatePresence>

      {/* Warm bottom gradient for label legibility */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />

      <div className="absolute bottom-4 left-4 right-4 flex justify-between text-[10px] tracking-[0.25em] uppercase font-semibold">
        <span
          className={`px-3 py-1.5 rounded-full backdrop-blur-md transition-all duration-700 ${
            phase === 0
              ? 'bg-white/90 text-[#1A2421] opacity-100'
              : 'bg-white/40 text-[#1A2421] opacity-50'
          }`}
        >
          Today
        </span>
        <span
          className={`px-3 py-1.5 rounded-full backdrop-blur-md transition-all duration-700 ${
            phase === 1
              ? 'bg-[#4A7C59] text-white opacity-100'
              : 'bg-white/40 text-[#1A2421] opacity-50'
          }`}
        >
          Your Vision
        </span>
      </div>
    </div>
  );
};

export default MorphingLandingVisual;
